import cx from 'clsx';
import React from 'react';

import { ReactComponent as DocumentTypeIcon } from '@assets/svg/file-types/small/ic-document.svg';
import { ReactComponent as ExcelTypeIcon } from '@assets/svg/file-types/small/ic-excel.svg';
import { ReactComponent as VideoTypeIcon } from '@assets/svg/file-types/small/ic-mp4.svg';
import { ReactComponent as PDFTypeIcon } from '@assets/svg/file-types/small/ic-pdf.svg';
import { ReactComponent as AudioTypeIcon } from '@assets/svg/file-types/small/ic-sound.svg';

import type { IFile } from '@model/file';

import style from './style.module.scss';

interface IProps {
  file: IFile;
}

const FilePreviewIcon = ({ file }: IProps) => {
  const { extension, name, url, isUploaded } = file;
  const loaderSpinner = !isUploaded;
  switch (extension) {
    case 'mp4':
      return (
        <VideoTypeIcon className={cx(style.iconSvg, { [style.loaderSpinner]: loaderSpinner })}>
          {name}
        </VideoTypeIcon>
      );
    case 'mp3':
      return (
        <AudioTypeIcon className={cx(style.iconSvg, { [style.loaderSpinner]: loaderSpinner })}>
          {name}
        </AudioTypeIcon>
      );
    case 'pdf':
      return (
        <PDFTypeIcon className={cx(style.iconSvg, { [style.loaderSpinner]: loaderSpinner })}>
          {name}
        </PDFTypeIcon>
      );
    case 'vnd.ms-excel':
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'csv':
      return (
        <ExcelTypeIcon className={cx(style.iconSvg, { [style.loaderSpinner]: loaderSpinner })}>
          {name}
        </ExcelTypeIcon>
      );
    case 'docx':
    case 'doc':
      return (
        <DocumentTypeIcon className={cx(style.iconSvg, { [style.loaderSpinner]: loaderSpinner })}>
          {name}
        </DocumentTypeIcon>
      );
    case 'jpeg':
    case 'jpg':
    case 'png':
    case 'svg':
      return (
        <img
          className={cx(style.imageType, { [style.loaderSpinner]: loaderSpinner })}
          src={url}
          onLoad={() => {
            url && URL.revokeObjectURL(url);
          }}
          alt={name}
        />
      );
    default:
      return (
        <DocumentTypeIcon className={cx(style.iconSvg, { [style.loaderSpinner]: loaderSpinner })}>
          {name}
        </DocumentTypeIcon>
      );
  }
};

export default FilePreviewIcon;
